var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCloudDownload = function SvgCloudDownload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 25"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8.672 2.758A8.75 8.75 0 0 1 17.3 8.75h.7a5.75 5.75 0 0 1 2.749 10.799.75.75 0 1 1-.718-1.317A4.25 4.25 0 0 0 18 10.25h-1.26a.75.75 0 0 1-.726-.562 7.25 7.25 0 1 0-12.452 6.615.75.75 0 0 1-1.124.994A8.75 8.75 0 0 1 8.672 2.758M11.47 22.03l-4-4a.75.75 0 1 1 1.061-1.06l2.72 2.72V12.5a.75.75 0 0 1 1.5 0v7.19l2.72-2.72a.75.75 0 1 1 1.06 1.06l-4 4a.75.75 0 0 1-.53.22m-.53-.22.005.005z",
    clipRule: "evenodd"
  })));
};
export default SvgCloudDownload;